import { Amplify } from 'aws-amplify'

export const env = process.env.REACT_APP_ENV === 'local' ? 'dev' : process.env.REACT_APP_ENV

export const configureAmplify = function () {
  const userPoolId = process.env.REACT_APP_AWS_USER_POOL_ID
  const userPoolClientId = process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID

  if (!userPoolId || !userPoolClientId) {
    console.error("Missing AWS Amplify configuration. Check your .env file.")
    return
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId,
      },
    },
  })
}
